import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { getFormValues } from 'redux-form'
import {
  Fade,
} from '@material-ui/core'
import { 
  Divider,
  Button
} from 'semantic-ui-react'

import { FileRow } from './FileRow'
import RFQAttachment from './RFQAttachment'
import { StdCard } from 'components'

import { ProcurementBody } from '../../../styled'
import { AttachmentInfoContainer } from './styled'
import { AttachmentContainer2, Cont2, SContDetail, AttachmentGroup, AttachmentContent } from './styled'


const Attachment = props => {
  const { isCreate, isEdit, change, sapDetails, valueForm } = props

  function setAttachment() {
    if (sapDetails.documentTypes) {
      let file = sapDetails.documentTypes.map((item, i) => {
        return {
          code: item.code,
          title: item.name,
          items: sapDetails.rfqAttachments.filter(
            item2 => item2.documentTypeCode === item.code
          ),
        }
      })
      file.push({
        code: 'RFQ04',
        title: 'เอกสารการต่อรองราคา',
        items: sapDetails.rfqAttachments.filter(
          item2 => item2.documentTypeCode === 'RFQ04'
        ),
      })
      return file.map((item, i) => {
        return <FileRow title={item.title} url={item.items} />
      })
    } else {
      return null
    }
  }

  var commentAttachments = sapDetails&&sapDetails.rfqAttachments?sapDetails.rfqAttachments.filter(x=>x.documentTypeCode==="RFQ02"):[]

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="Attachment">
          {isCreate || isEdit ? (
            <RFQAttachment change={change} />
          ) : (
            <AttachmentInfoContainer>
              {setAttachment()}
            </AttachmentInfoContainer>
          )}
          <div>
            <span>หมายเหตุ / Note: </span>
            <ul style={{marginTop:'0.3rem'}}>
              <li>รองรับได้สูงสุด 250 MB ต่อไฟล์ / The maximum file size is 250 MB (per file).</li>
              <li>ความเร็วและข้อผิดพลาดในการอัพโหลด/ดาวน์โหลดไฟล์ขนาดใหญ่ ขึ้นอยู่กับอินเตอร์เน็ตที่ท่านใช้งาน / The speed and error in uploading or downloading depend on your internet connection.</li>
            </ul>
          </div>
        </StdCard>
        {
          commentAttachments.length ? 
            <StdCard title='Attachments (from comment)' style={{ marginTop: '15px' }} >
              <AttachmentContainer2>
                <Cont2>
                  {
                    sapDetails.rfqComments.map(a => {
                      let files = commentAttachments.filter(x=>x.commentId===a.id)
                      if(files.length){
                        return(
                          <AttachmentGroup>
                            <div className='attachmentBy'>
                              <span>{a.createdByName}</span>
                              <Moment format='DD MMM YYYY hh:mm'>{a.createdDate}</Moment>
                            </div>
                            <AttachmentContent>
                              {
                                files.map((f,i) => 
                                  <SContDetail style={i==0?{ marginTop: '0px' }:null}>
                                    {/* <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(f.urlPath,"_blank"))}/> */}
                                    <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = f.urlPath)}/>
                                  </SContDetail>
                                )
                              }
                              <Divider/>
                            </AttachmentContent>
                          </AttachmentGroup>
                        )
                      }else{
                        return null
                      }
                      
                    })
                  }
                </Cont2>
              </AttachmentContainer2>
            </StdCard> : null
        }
      </ProcurementBody>
    </Fade>
  )
  
}
const mapStateToProps = (state, props) => {
  return {
    sapDetails: state.rfq.sapDetails.data,
    valueForm: getFormValues('formRFQ')(state),
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Attachment)
